export default function initSelectAll() {
    const selectAllCheckbox = document.querySelectorAll('[select-all]');

    for (let i = 0; i < selectAllCheckbox.length; i++) {
        const parent = selectAllCheckbox[i].getAttribute('select-all');
        const checkboxGroup = document.querySelectorAll(`${parent} input[type=checkbox]`);

        selectAllCheckbox[i].addEventListener('change', (evt) => {
            if(parent) {
                for (let j = 0; j < checkboxGroup.length; j++) {
                    checkboxGroup[j].checked = selectAllCheckbox[i].checked;
                }
            }
        });

        for (let j = 0; j < checkboxGroup.length; j++) {
            checkboxGroup[j].addEventListener('change', (evt) => {
                if(evt.target.checked === false) {
                    selectAllCheckbox[i].checked = checkboxGroup[j].checked;
                } else {
                    let checkedBoxes = document.querySelectorAll(`${parent} input[type=checkbox]:checked`);
                    if(checkedBoxes.length === checkboxGroup.length - 1) {
                        selectAllCheckbox[i].checked = checkboxGroup[j].checked;
                    }
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/select-all.js